import { DEFAULT_BRAND_ID, DEFAULT_COLOR_SCHEME } from "./defaults-i_xG2F_1.js";
import { BRAND_ATTRIBUTE, THEME_ATTRIBUTE, ThemeScopeContainerContext, ThemeScopeSchemeContext } from "./useColorSchemeState-Cw4MCXUs.js";
import { use, useMemo, useSyncExternalStore } from "react";
//#region src/components/ThemeProvider/useThemeAttributes.ts
const DEFAULT_ATTRIBUTES = {
	cacheKey: `${DEFAULT_COLOR_SCHEME}:${DEFAULT_BRAND_ID}`,
	scheme: DEFAULT_COLOR_SCHEME,
	brandId: DEFAULT_BRAND_ID,
	scope: null
};
let snapshot = DEFAULT_ATTRIBUTES;
const readThemeAttributes = () => {
	if (typeof document === "undefined") return DEFAULT_ATTRIBUTES;
	const root = document.documentElement;
	const theme = root.getAttribute(THEME_ATTRIBUTE);
	const scheme = theme === "dark" || theme === "light" ? theme : DEFAULT_COLOR_SCHEME;
	const brandId = root.getAttribute("data-brand") ?? "design-system";
	const cacheKey = `${scheme}:${brandId}`;
	if (cacheKey !== snapshot.cacheKey) snapshot = {
		cacheKey,
		scheme,
		brandId,
		scope: null
	};
	return snapshot;
};
const subscribe = (onChange) => {
	if (typeof document === "undefined") return () => {};
	const observer = new MutationObserver(onChange);
	observer.observe(document.documentElement, {
		attributes: true,
		attributeFilter: [THEME_ATTRIBUTE, BRAND_ATTRIBUTE]
	});
	return () => observer.disconnect();
};
const getServerSnapshot = () => DEFAULT_ATTRIBUTES;
/**
* Colour scheme and brand applied to `<html>`, plus a key for memoizing `resolveToken` output.
*
* - Read from the DOM, not `useTheme()`: `ThemeProvider` sets the attributes in passive effects,
*   so context flips a render before the computed `--*` values do.
* - Key and scheme come from one read, so they cannot disagree.
* - Inside a `ThemeScope` its scheme wins; it commits attribute and vars with the subtree.
*/
const useThemeAttributes = () => {
	const root = useSyncExternalStore(subscribe, readThemeAttributes, getServerSnapshot);
	const scopedScheme = use(ThemeScopeSchemeContext);
	const scope = use(ThemeScopeContainerContext);
	return useMemo(() => {
		if (scopedScheme === null && scope === null) return root;
		const scheme = scopedScheme ?? root.scheme;
		return {
			scheme,
			brandId: root.brandId,
			scope,
			cacheKey: `${scheme}:${root.brandId}${scope === null ? "" : ":scoped"}`
		};
	}, [
		scopedScheme,
		scope,
		root
	]);
};
//#endregion
export { useThemeAttributes };

//# sourceMappingURL=useThemeAttributes-B199Regy.js.map